"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeEmailButton = exports.BlackAuthButton = exports.EmailVerificationInputDiv = void 0;
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.EmailVerificationInputDiv = styled_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  @keyframes fade_in {
    to {
      opacity: 1;
    }
  }
  opacity: 0;
  animation: fade_in 0.3s ease forwards;
  input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    transition: background-color 0.3s ease;
    :disabled {
      padding: 11px 13px;
      border: 0;
      background-color: #f8f8f8;
      opacity: 1;
      -webkit-text-fill-color: inherit;
    }
  }
`;
exports.BlackAuthButton = (0, styled_1.default)(Button_1.default) `
  position: absolute;
  right: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 15px;
  line-height: 17px;
  background-color: black !important;
  color: white;
  opacity: 0;
  animation: fade_in 0.3s ease forwards;
`;
exports.ChangeEmailButton = (0, styled_1.default)(Button_1.default) `
  position: absolute;
  right: 6px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.8);
  border-radius: 6px;
  font-size: 15px;
  line-height: 17px;
  background-color: white !important;
  color: rgba(0, 0, 0, 0.8);
  opacity: 0;
  animation: fade_in 0.3s ease forwards;
`;
